import { FormField } from "@common";

/**
 * Renders one input per configured other-profit tier, styled the same as the
 * other fields in `CostProductionBreakdownForm` (2-column grid of FormField).
 *
 * Only the tier label is shown; percentage / computed profit are intentionally
 * hidden here — they are stored on the submitted record and displayed elsewhere
 * (AssociateFee / Journal Entry / DDS Draw tooltip / PDF).
 *
 * Props:
 *  - tiers: Array<{ label: string, percent: number|string }>
 *  - values: Array<string>     raw per-tier input_value strings, index-aligned with `tiers`
 *  - onChange: (nextValues: Array<string>) => void
 *  - errors?: Array<string>    per-tier error message, index-aligned with `tiers`
 *  - showErrors?: boolean
 *  - disabled?: boolean
 */
export default function OtherProfitTierInputs({
  tiers,
  values,
  onChange,
  errors = [],
  showErrors = false,
  disabled = false,
}) {
  if (!Array.isArray(tiers) || tiers.length === 0) return null;

  const handleValueChange = (idx) => (e) => {
    const next = Array.isArray(values) ? values.slice() : [];
    next[idx] = e.target.value;
    onChange(next);
  };

  return (
    <div className="mt-4">
      <div className="grid gap-4 md:grid-cols-2">
        {tiers.map((tier, idx) => (
          <FormField
            key={`${tier.label}-${idx}`}
            label={tier.label}
            placeholder=""
            type="number"
            value={values?.[idx] ?? ""}
            onChange={handleValueChange(idx)}
            error={errors[idx]}
            showError={showErrors}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}
